const FREE_PACKAGE = 'FREE_PACKAGE';
const PACKAGE_ALL_IN_ONE = 'ALL_IN_ONE';
const PACKAGE_GROW = 'GROW';
const PACKAGE_PLUS_VIDEO = 'PLUS_VIDEO';
const PACKAGE_RESET = 'PACKAGE_RESET';

export { FREE_PACKAGE, PACKAGE_ALL_IN_ONE, PACKAGE_GROW, PACKAGE_PLUS_VIDEO, PACKAGE_RESET };
